import React from 'react';
import {Project} from '../../../../data/models/Projects/Project';
import Tooltip from '../../../../uiToolkit/Tooltip';
import {Icon} from '../../../../uiToolkit/Icon/Icon';
import MicroreelCardOptions from '../../../Microreels/List/components/MicroreelCardOptions';
import {formatTimeAgo} from '../../../../utils/notificationTimeTextConvertor';
import {projectsText} from '../../projectsText';
import styles from './ProjectCard.module.css';

const GHOST_DEPTH_CLASS = [styles.ghostOne, styles.ghostTwo, styles.ghostThree];

interface Props {
  project: Project;
  canManage: boolean;
  onOpen: (project: Project) => void;
  onRename: (project: Project) => void;
  onDelete: (project: Project) => void;
}

const ProjectCard = React.memo(
  ({project, canManage, onOpen, onRename, onDelete}: Props) => {
    const timeAgo = formatTimeAgo(project.dateUpdated);
    const options = [
      {label: projectsText.open, onClick: () => onOpen(project)},
      ...(canManage
        ? [
            {label: projectsText.rename, onClick: () => onRename(project)},
            {
              label: projectsText.delete,
              onClick: () => onDelete(project),
              danger: true,
            },
          ]
        : []),
    ];

    const stacked =
      project.coursesNumber + project.microreelsNumber + project.postsNumber >
      1;

    return (
      <div
        className={`${styles.cardContainer} ${stacked ? styles.stacked : ''}`}>
        {stacked &&
          GHOST_DEPTH_CLASS.map((depthClass, index) => (
            <span key={index} className={`${styles.ghost} ${depthClass}`} />
          ))}
        <div className={styles.card} onClick={() => onOpen(project)}>
          <div className={styles.iconContainer}>
            <Icon name="projects-menu.svg" className={styles.icon} />
          </div>
          <div className={styles.info}>
            <Tooltip tooltipText={project.name}>
              <p className={styles.name}>{project.name}</p>
            </Tooltip>
            <span className={`${styles.meta} ${styles.counts}`}>
              {projectsText.contentSummary(project)}
            </span>
            {timeAgo && (
              <span className={styles.meta}>
                {projectsText.updatedAgo(timeAgo)}
              </span>
            )}
          </div>
        </div>
        <div
          className={styles.optionsPosition}
          onClick={ev => ev.stopPropagation()}>
          <MicroreelCardOptions options={options} />
        </div>
      </div>
    );
  },
);

export default ProjectCard;
